<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="100"
            :has-details-row="true"
            :selectable-rows="false"
          >
            <template #row-details="row">
              <appointment-grid-details-row :row="row" />
            </template>
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(articleId)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.articleId" />
            </template>
            <template #head(stock)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.stock"
                input-type="number"
              />
            </template>
            <template #head(availabilityDate)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.availabilityDate" />
            </template>
            <template #head(appointment1)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.appointment1"
                input-type="number"
              />
            </template>
            <template #head(appointmentString1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.appointmentString1" />
            </template>
            <template #head(appointmentQuality1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.appointmentQuality1" />
            </template>
            <template #head(primaryKey)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.primaryKey" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import AppointmentGridDetailsRow from './appointment-grid-details-row';
import PageHeader from '../../structure/page-header';
import TableFilter from '../../table/table-filter';

export default {
  name: 'AppointmentGrid',
  components: { PageHeader, AppointmentGridDetailsRow, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        rows: [],
        fields: [
          { key: 'check', label: '', tdClass: 'check', thClass: 'check' },
          { key: 'company', label: this.$translate('company') },
          { key: 'articleId', label: this.$translate('article') },
          { key: 'stock', label: `${this.$translate('stock')}` },
          {
            key: 'availabilityDate',
            label: `${this.$translate('availability_date')}`,
          },
          { key: 'appointment1', label: `${this.$translate('appointment')} 1` },
          {
            key: 'appointmentString1',
            label: `${this.$translate('appointment_string')} 1`,
          },
          {
            key: 'appointmentQuality1',
            label: `${this.$translate('appointment_quality')} 1`,
          },
          {
            key: 'availableQuantity1',
            label: `${this.$translate('available_quantity')} 1`,
          },
          {
            key: 'availableQuantitySalesUnit1',
            label: `${this.$translate('available_quantity_sales_unit')} 1`,
          },
          { key: 'primaryKey', label: this.$translate('primary_key') },
        ],
        filter: {
          company: null,
          articleId: null,
          stock: null,
          availabilityDate: null,
          appointment1: null,
          appointmentString1: null,
          appointmentQuality1: null,
          primaryKey: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getAppointmentGridPage(ctx);
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
// @media (max-width: 991px) {
//   .main-content {
//     max-height: calc(100vh - 100px);
//   }
// }

::v-deep   .table {
  min-width: 1000px;

  th,
  td {
    &.check {
      width: 3%;
    }
  }
}
</style>
